import React from 'react';
import classNames from 'classnames/bind';
import { Icon, ICONS, Tooltip, TooltipPosition } from '@creditsights/styleguide-web';
import { useGlobalModalContext } from '../../../GlobalModal';
import { MODAL_TYPES } from '../../../GlobalModal/GlobalModal';
import styles from './InfoButton.module.scss';

const cx = classNames.bind(styles);

interface InfoButtonProps {
  tooltipPosition: TooltipPosition;
}

const InfoButton = ({ tooltipPosition }: InfoButtonProps): React.ReactElement => {
  const { showModal } = useGlobalModalContext();
  const onButtonClick = () => {
    showModal(MODAL_TYPES.CS_VIEW);
  };

  return (
    <Tooltip
      trigger={
        <button
          type="button"
          className={cx('info-button')}
          onClick={onButtonClick}
          data-testid="info-button"
          aria-label="More on CS View"
        >
          <Icon name={ICONS.Info} dataTestId="info-button-icon" />
        </button>
      }
      content="More on CS View"
      position={tooltipPosition}
    />
  );
};

export default InfoButton;
